"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionItemPriorityOverride = exports.ActionItemCode = void 0;
/**
 * The type of actionItem a person will be notified to fulfill
 */
var ActionItemCode;
(function (ActionItemCode) {
    /**
     * - The action is not connected to any data silos or data points
     */
    ActionItemCode["ActionMissingSilos"] = "ACTION_MISSING_SILOS";
    /**
     * API Keys that are too old (expired)
     */
    ActionItemCode["ApiKeyStale"] = "API_KEY_STALE";
    /**
     * An assessment has been assigned for completion
     */
    ActionItemCode["AssessmentFormAssigned"] = "ASSESSMENT_FORM_ASSIGNED";
    /**
     * An assessment needs review
     */
    ActionItemCode["AssessmentFormNeedsReview"] = "ASSESSMENT_FORM_NEEDS_REVIEW";
    /**
     * Someone marked a request as requiring manual review
     */
    ActionItemCode["RequestDataSiloMarkedActionable"] = "REQUEST_DATA_SILO_MARKED_ACTIONABLE";
    /**
     * There are files for a data silo in a request that require manual review
     */
    ActionItemCode["RequestDataSiloFilesNeedReview"] = "REQUEST_DATA_SILO_FILES_NEED_REVIEW";
    /**
     * - Unread emails with the data subject
     */
    ActionItemCode["CommunicationUnread"] = "COMMUNICATION_UNREAD";
    /**
     * - Unread emails with a vendor
     */
    ActionItemCode["DataSiloCommunicationUnread"] = "DATA_SILO_COMMUNICATION_UNREAD";
    /**
     * - The description is the empty string
     * - There is no data collection
     */
    ActionItemCode["DataPoint"] = "DATA_POINT";
    /**
     * - Data point has missing fields
     */
    ActionItemCode["DataPointMissingFields"] = "DATA_POINT_MISSING_FIELDS";
    /**
     * - Data Silos not are EXPIRED, PERMISSIONS_UPDATED or misconfigured and are not assigned yet
     */
    ActionItemCode["DataSiloNeedsReconnect"] = "DATA_SILO_NEEDS_RECONNECT";
    /**
     * - Data Silos not are EXPIRED, PERMISSIONS_UPDATED or misconfigured and are assigned
     */
    ActionItemCode["DataSiloNeedsReconnectAssigned"] = "DATA_SILO_NEEDS_RECONNECT_ASSIGNED";
    /**
     * - Data Silos that are not yet brought online and launched into production and are not assigned yet
     */
    ActionItemCode["DataSiloNotConfigured"] = "DATA_SILO_NOT_CONFIGURED";
    /**
     * - Data Silos that are not yet brought online and launched into production and are assigned
     */
    ActionItemCode["DataSiloNotConfiguredAssigned"] = "DATA_SILO_NOT_CONFIGURED_ASSIGNED";
    /**
     * - Data Silos that are live and have no configured identifiers are invalid
     */
    ActionItemCode["DataSiloMissingIdentifiers"] = "DATA_SILO_MISSING_IDENTIFIERS";
    /**
     * - Lookup processes have errored out and are no longer indexing
     */
    ActionItemCode["LookupProcessesWithErrors"] = "LOOKUP_PROCESSES_WITH_ERRORS";
    /**
     * Manual entry is required for prompt a person data silo
     * or a file was marked as requiring action item.
     */
    ActionItemCode["DataSilosNeedingManualEntry"] = "DATA_SILOS_NEEDING_MANUAL_ENTRY";
    /**
     * - A profile running a specific datapoint encountered an error
     */
    ActionItemCode["ProfileDataPointStatus"] = "PROFILE_DATA_POINT_STATUS";
    /**
     * - The request is nearing its expiry time
     */
    ActionItemCode["RequestExpiry"] = "REQUEST_EXPIRY";
    /**
     * - A request data silo that has thrown an error
     */
    ActionItemCode["RequestDataSiloError"] = "REQUEST_DATA_SILO_ERROR";
    /**
     * - enricher that has an error
     */
    ActionItemCode["RequestEnricherError"] = "REQUEST_ENRICHER_ERROR";
    /**
     * RequestIdentifier needs to be manually verified
     */
    ActionItemCode["RequestIdentifierNeedsVerification"] = "REQUEST_IDENTIFIER_NEEDS_VERIFICATION";
    /**
     * - Enrichers of type PERSON that are awaiting manual entry
     */
    ActionItemCode["RequestEnricherPersonNeedsManualEntry"] = "REQUEST_ENRICHER_PERSON_NEEDS_MANUAL_ENTRY";
    /**
     * - request needs approvals
     */
    ActionItemCode["RequestActionableStatus"] = "REQUEST_ACTIONABLE_STATUS";
    /**
     * - request is on hold
     */
    ActionItemCode["RequestOnHold"] = "REQUEST_ON_HOLD";
    /**
     * - A user who hasn't been notified that they've been added to an org.
     */
    ActionItemCode["UserAwaitingNotification"] = "USER_AWAITING_NOTIFICATION";
    /**
     * - A user created with no scopes or no teams
     */
    ActionItemCode["UserNeedsConfiguration"] = "USER_NEEDS_CONFIGURATION";
    /**
     * - Old Sombra version upgrade reminder
     */
    ActionItemCode["SombraVersionUpgrade"] = "SOMBRA_VERSION_UPGRADE";
    /**
     * - Sombra key rotation reminder
     */
    ActionItemCode["SombraNeedsKeyRotation"] = "SOMBRA_NEEDS_KEY_ROTATION";
    /**
     * - Data Flows that need review
     */
    ActionItemCode["DataFlowNeedsReview"] = "DATA_FLOW_NEEDS_REVIEW";
    /**
     * - Data Flows that have been assigned for review
     */
    ActionItemCode["DataFlowAssignedForReview"] = "DATA_FLOW_ASSIGNED_FOR_REVIEW";
    /**
     * - Cookies that need review
     */
    ActionItemCode["CookieNeedsReview"] = "COOKIE_NEEDS_REVIEW";
    /**
     * - Cookies that have been assigned for review
     */
    ActionItemCode["CookieAssignedForReview"] = "COOKIE_ASSIGNED_FOR_REVIEW";
    /**
     * - Consent Manager bundle version can be upgraded
     */
    ActionItemCode["ConsentManagerVersionUpgrade"] = "CONSENT_MANAGER_VERSION_UPGRADE";
    /**
     * - Lookup processes have errored out and are no longer indexing
     */
    ActionItemCode["PluginsWithErrors"] = "PLUGINS_WITH_ERRORS";
    /**
     * onboarding action item, user-defined with no query handlers
     */
    ActionItemCode["Onboarding"] = "ONBOARDING";
    /**
     * request that has been assigned to a user
     */
    ActionItemCode["RequestAssignedToUser"] = "REQUEST_ASSIGNED_TO_USER";
    /**
     * a dataSilo that has less than 80% of discovered sub data points classified
     */
    ActionItemCode["DataSiloNeedsTraining"] = "DATA_SILO_NEEDS_TRAINING";
    /**
     * business entity needing documentation
     */
    ActionItemCode["BusinessEntityNeedsDocumentation"] = "BUSINESS_ENTITY_NEEDS_DOCUMENTATION";
    /**
     * A database datapoint has queries that need approval
     */
    ActionItemCode["DataPointDatabaseQueryNeedsApproval"] = "DATA_POINT_DATABASE_QUERY_NEEDS_APPROVAL";
})(ActionItemCode || (exports.ActionItemCode = ActionItemCode = {}));
/**
 * Possible values for action item priority override
 */
var ActionItemPriorityOverride;
(function (ActionItemPriorityOverride) {
    ActionItemPriorityOverride["WontDo"] = "WONT_DO";
    ActionItemPriorityOverride["Low"] = "LOW";
    ActionItemPriorityOverride["Medium"] = "MEDIUM";
    ActionItemPriorityOverride["High"] = "HIGH";
    ActionItemPriorityOverride["Critical"] = "CRITICAL";
})(ActionItemPriorityOverride || (exports.ActionItemPriorityOverride = ActionItemPriorityOverride = {}));
//# sourceMappingURL=actionItems.js.map